export default {
    nl: {
        intro: {
            subtitle: 'Klantportaal',
            title: 'Je eigen ingang.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/client-portal/hero.jpg',
        },
        type: 'Klantportaal',
        title: 'Klantportaal: Voor digitale communicatie met vertrouwen',
        description:
            'Een klantportaal op maat voor optimale dienstverlening. Regel transacties, bekijk informatie en beheer accounts met gemak & veiligheid.',
        content: [
            {
                type: 'text',
                title: 'Klantportaal',
                content:
                    'Als digital agency begrijpen we dat communicatie in de digitale wereld meer dan ooit draait om vertrouwen en flexibiliteit. Daarom is het essentieel dat we onze klanten een veilige, intuïtieve en responsieve omgeving bieden. Enter: ons klantportaal.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/meeting-developer.webp',
                ],
            },
            {
                type: 'text',
                title: '24/7 Bereikbaarheid voor jouw klanten',
                content: `
                    Een klantportaal is dé plek waar al jouw klanten alles kunnen regelen! Of het nu gaat om het bekijken van facturen, het plaatsen van bestellingen, of het simpelweg bijwerken van accountgegevens, alles is mogelijk. En dat allemaal op het moment dat het hen uitkomt.
                    <br><br>
                    Omdat we begrijpen dat elke klant andere behoeften heeft, maken we het klantportaal op maat. Voordat we daadwerkelijk het design proces beginnen, verdiepen we ons in de klantbehoeften door middel van user stories en UX research, zodat het portaal niet alleen functioneert, maar ook intuïtief aanvoelt met een gebruiksvriendelijke UI/UX-design.
                `,
            },
            {
                type: 'text',
                title: 'Voordelen van ons klantportaal',
                content:
                    'Klantportalen bieden voordelen voor zowel de klant als het bedrijf. Door koppelingen met ons ERP-systeem en geavanceerde back-end development technieken, halen we data uit diverse bronnen samen en automatiseren we processen. Dit zorgt voor een gestroomlijnde ervaring voor de gebruiker en een ongeëvenaarde service voor onze klant.',
            },
            {
                type: 'case',
                case: 'cbre',
            },
        ],
        related_services: ['intranet', 'front-end-development', 'api'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
